export default "__VITE_ASSET__31a89b5e__"